<template>
  <div class="section overflow-hidden position-relative" id="wrapper">

    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-left-0">
      <div class="container-fluid custom-container">

        <!-- Message Start -->
        <div class="" >
          <div class="message-content">
            <h3>Questions List:</h3>

          </div>
        </div>
        <!-- Message End -->

        <!-- Your Packages Start -->
        <div class="section section-padding mt-n10 padding-top-50">
          <Table :data="questions" :columnsToShow="['question', 'image', 'options', 'ans', 'complexity', 'created_by']">
            <template #cell-image="{ row }">
                <img v-if="row.question_image" :src="get_img(row._id)" alt="Question Image" class="question-img mb-2" width="200" />
            </template>
          </Table> 
        </div>
        <!-- Packages End -->

      </div>
    </div>
    <!-- Page Content Wrapper End -->
  </div>
</template>
<script>

import Table from '@/components/reusable/Table.vue';
import {fetchAllQuestions } from '@/services/adminService';
import { AppConfig } from '@/constants';
export default {
  name: 'QuestionsDetails',
  components:{Table},
  data(){
    return{
      questions: []
    }
  },
  async mounted(){
    this.questions = await fetchAllQuestions();
  },
  methods:{
    get_img(id) {
      return AppConfig.API_BASE_URL + `/test/get_question_image/${id}`;
    }
  }
}
</script>